/*
 * @Author: your name
 * @Date: 2021-01-04 14:45:45
 * @LastEditTime: 2021-01-12 10:41:51
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: /soci-frontend/src/main.js
 */
import Vue from 'vue'
import Cookies from 'js-cookie'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Clipboard from 'v-clipboard'
import Router from 'vue-router'
import App from './App.vue'
import routes from "@/route/routes";


Vue.use(ElementUI);
Vue.use(Clipboard)

Vue.config.productionTip = false


//push
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
    return VueRouterPush.call(this, to).catch(err => err)
}

//replace
const VueRouterReplace = Router.prototype.replace
Router.prototype.replace = function replace (to) {
  return VueRouterReplace.call(this, to).catch(err => err)
}

Vue.use(Router)


const createRouter = () => new Router({
    mode: 'history',
    routes: routes
})



const router = createRouter()
export function resetRouter () {
    const newRouter = createRouter()
    router.matcher = newRouter.matcher
}


const LOGIN_NAME = 'login'
const MAIN_NAME = 'home' // 主路由name

export const getToken = () => {
    const token = Cookies.get('auth-token')
    if (token) return token
    else return false
}

router.beforeEach((to, form, next) => {
    let token = getToken();
    if (!token) {
        if (
            to.name === LOGIN_NAME ||
            to.name === undefined
        ) {
            next();
        } else {
            next({ name: LOGIN_NAME });
        }
        resetRouter();
    } else {
        if (to.name === LOGIN_NAME) {
            next({ name: MAIN_NAME });
        } else {
            next();
        }
    }
});


new Vue({router:router,
  render: h => h(App),
}).$mount('#app')
